import { Paper } from "@mantine/core"
import { ReactNode } from "react"
import { IPermissionCode, usePermission } from "./index"

type Props = {
  code: IPermissionCode
  children: ReactNode
}

/** Route guard: эрхгүй бол шууд URL-аар орсон ч «хандах эрхгүй» карт харуулна. */
export function RequirePermission({ code, children }: Props) {
  const { hasAccess, accessDenied } = usePermission(code)
  if (!hasAccess) return <Paper p="xs">{accessDenied()}</Paper>
  return <>{children}</>
}
